<template>
  <div class="quiz__tiles">
      <div
        v-for="(item, i) in quizItems"
        :key="`item-${i}`"
        class="quiz__tile"
      >
        <slot :item="item"></slot>
      </div>
  </div>
</template>
<script>
import _ from "lodash";

export default {
  name: "Tiles",
  props: {
    items: { type: Array, default: () => [] }
  },

  computed: {
    quizItems: function() {
      return this.items;
    }
  }
};
</script>